export default __webpack_public_path__ + "static/media/fancyunderline2.48b82ddc.png";